import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'
import s from './RouteFallback.module.css'

export default function RouteFallback() {
  return (
    <div className={s.fallback} role="status" aria-live="polite">
      <LoadingSpinner />
    </div>
  )
}
